"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentAuditVaccinationComparisonDtoVaccinationCodeEnum = void 0;
exports.instanceOfDocumentAuditVaccinationComparisonDto = instanceOfDocumentAuditVaccinationComparisonDto;
exports.DocumentAuditVaccinationComparisonDtoFromJSON = DocumentAuditVaccinationComparisonDtoFromJSON;
exports.DocumentAuditVaccinationComparisonDtoFromJSONTyped = DocumentAuditVaccinationComparisonDtoFromJSONTyped;
exports.DocumentAuditVaccinationComparisonDtoToJSON = DocumentAuditVaccinationComparisonDtoToJSON;
exports.DocumentAuditVaccinationComparisonDtoToJSONTyped = DocumentAuditVaccinationComparisonDtoToJSONTyped;
/**
 * @export
 */
exports.DocumentAuditVaccinationComparisonDtoVaccinationCodeEnum = {
    Covid19: 'COVID_19',
    Hepatitis: 'HEPATITIS',
    Influenza: 'INFLUENZA',
    MeaslesMumpsRubella: 'MEASLES_MUMPS_RUBELLA',
    Tdap: 'TDAP',
    Varicella: 'VARICELLA'
};
/**
 * Check if a given object implements the DocumentAuditVaccinationComparisonDto interface.
 */
function instanceOfDocumentAuditVaccinationComparisonDto(value) {
    if (!('vaccinationCode' in value) || value['vaccinationCode'] === undefined)
        return false;
    if (!('claimedDate' in value) || value['claimedDate'] === undefined)
        return false;
    if (!('matched' in value) || value['matched'] === undefined)
        return false;
    return true;
}
function DocumentAuditVaccinationComparisonDtoFromJSON(json) {
    return DocumentAuditVaccinationComparisonDtoFromJSONTyped(json, false);
}
function DocumentAuditVaccinationComparisonDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'vaccinationCode': json['vaccinationCode'],
        'claimedDate': json['claimedDate'],
        'matched': json['matched'],
    };
}
function DocumentAuditVaccinationComparisonDtoToJSON(json) {
    return DocumentAuditVaccinationComparisonDtoToJSONTyped(json, false);
}
function DocumentAuditVaccinationComparisonDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'vaccinationCode': value['vaccinationCode'],
        'claimedDate': value['claimedDate'],
        'matched': value['matched'],
    };
}
//# sourceMappingURL=DocumentAuditVaccinationComparisonDto.js.map